import { Reveal, ChapterTag } from "@/components/Reveal";

const FOUNDER_IMG = "/founder.jpeg";

export const Founder = () => (
  <section data-testid="founder-section" className="grain relative bg-obsidian px-5 py-20 sm:px-8 sm:py-28 lg:px-16 lg:py-36">
    <div className="mx-auto max-w-7xl">
      <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-12 lg:gap-20">
        <Reveal className="lg:col-span-4">
          <div className="group relative mx-auto max-w-sm overflow-hidden rounded-sm">
            <img
              src={FOUNDER_IMG}
              alt="Ayush Raj Jaiswal, Founder of Nivaan Experiences"
              className="aspect-[4/5] w-full object-cover transition-transform duration-[1.6s] ease-out group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0C0D0F]/50 via-transparent to-transparent" />
            <div className="absolute inset-3 rounded-sm border border-gold/25" />
          </div>
        </Reveal>
        <div className="lg:col-span-8">
          <Reveal>
            <ChapterTag index="09" label="The Founder" />
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-10 font-serif text-4xl font-light leading-tight tracking-tight text-zinc-50 sm:text-5xl">
              Meet the <span className="italic text-gold-gradient">Founder</span>
            </h2>
          </Reveal>
          <Reveal delay={0.2}>
            <p data-testid="founder-name" className="mt-8 font-serif text-2xl font-normal text-zinc-100 sm:text-3xl">
              Ayush Raj Jaiswal
            </p>
            <p className="mt-2 text-[11px] font-mono uppercase tracking-[0.3em] text-gold">
              Founder & CEO, Nivaan Experiences
            </p>
            <p className="mt-6 max-w-xl text-base font-light leading-relaxed text-zinc-400 sm:text-lg">
              Building Nivaan Experiences from the ground up with a focus on personalized service,
              attention to detail and memorable journeys.
            </p>
            <a
              data-testid="founder-instagram-link"
              href="https://instagram.com/imunfilteredayush"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-8 inline-block border-b border-gold/40 pb-1 text-xs font-medium uppercase tracking-[0.25em] text-zinc-300 transition-colors duration-300 hover:border-gold hover:text-gold"
            >
              @imunfilteredayush
            </a>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
